import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import Styles from "./styles.module.scss";
import SearchBar from "../../components/searchbar";
import Button from "../../components/button";
import PopupMenu from "../../components/popupmenu";
import Breadcrumbs from "../../components/breadCrumbs";
import {
  BreadcrumbLinkMouseEvent,
  DataModel,
} from "@progress/kendo-react-layout";
import { priorityClass, checkPriority, checkTimesheetStatus } from '../../utils/EllowUtils';
import classnames from "classnames";
import IncontractFilter from "../../modal/incontractFilter";
import PositionFilter from "../../modal/positionFilter";
import ResourceFilter from "../../modal/resourceFilter";

interface Props {
  title: any;
  navigateTo?: any;
  searchChange: any;
  popupMenu?: boolean;
  jobId?: string;
  candidateLoginId?: string;
  updatePosition?: any;
  onClick?: any;
  filterNumber?: any;
  filterValues?: any;
  closeTag?: any;
  type?: string;
  companyList?: any;
  allocatedTo?: any;
  applyFilter?: any;
  applyResourceFilter?:any;
  applyCompanyFilter?:any;
  positionName?: any;
  jobStatus?: number;
  companyName?: any;
  priority?: any;
  shareButton?: boolean;
  onShareClick?: any;
  createTimeSheet?: any;
  timesheetStatus?: any;
  applyIncontractResourceFilter?: any;
  skillsList?: any;
  jobRolesList?: any;

}

const DashboardHeader: React.FC<Props> = ({
  title,
  navigateTo,
  searchChange,
  popupMenu,
  jobId,
  candidateLoginId,
  filterNumber,
  updatePosition,
  filterValues,
  closeTag,
  companyList,
  allocatedTo,
  type,
  applyFilter,
  applyCompanyFilter,
  positionName,
  jobStatus,
  applyResourceFilter,
  companyName,
  priority,
  shareButton,
  onShareClick,
  createTimeSheet,
  timesheetStatus,
  applyIncontractResourceFilter,
  skillsList,
  jobRolesList,
  ...rest
}) => {

  const navigate = useNavigate();
  const [filter, setFilter] = useState<boolean>(false)
  const [resourceFilter, setResourceFilter] = useState<boolean>(false)
  const [incontractResourceFilter, setIncontractResourceFilter] = useState<boolean>(false)
  const [defaultValues, setDefaultValues] = useState<any>()
  const [search, setSearch] = useState(null)
  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(() => {
  
    if (debouncedSearchTerm !== null ) {
      searchChange && searchChange(debouncedSearchTerm)
    }
  }, [debouncedSearchTerm, searchChange])

  const changeSearch = (e: any) => { 
    setSearch(e) 
  }

  const headerNavigation = () => {
    if (navigateTo === "/createResources") {
      navigate(navigateTo, {
        state: {
          candidateLoginId: candidateLoginId,
        },
      });
    }else if (navigateTo === "../createCompany") {
      navigate(navigateTo, {
        state: {
          candidateLoginId: candidateLoginId,
        },
      });
    }
    else if (navigateTo === "../addTimesheet") {
     createTimeSheet()
    }
    else {
      navigate(navigateTo);
    }
  };

  let item: DataModel[] =
    title &&
    title.map((item: any, key: number) => {
      return {
        id: key + 1,
        text: item,
      };
    });

  const onselect = (event: BreadcrumbLinkMouseEvent) => {
    if (event.id === 'Positions') {      
      navigate('../positions')
    }
    if (event.id === 'Resources') {      
      navigate('../resources')
    } 
    if (event.id === 'Companies') {      
      navigate('../company')
    }  
    if (event.id === 'Resources in Contract') {
      navigate('/incontract')
    }    
  }

  const clickHandler = (data: any, name:string) => {    
    if (name === 'positions') { 
     applyFilter(data)
     setFilter(false)
   }
    if (name === 'incontractresources') {
      let value: any = {
        filters: {
          "duration": {
            "startDateFrom": data && data.contractDuration.startDateFrom,
            "startDateTo": data && data.contractDuration.startDateTo,
            "endDateFrom": data && data.contractDuration.endDateFrom,
            "endDateTo": data && data.contractDuration.endDateTo
        }
        },
      }
     applyIncontractResourceFilter(value)     
      setIncontractResourceFilter(false)
    }
    if(name === 'company'){            
      applyCompanyFilter(data)
    }

    if (name === 'resources') {
      applyResourceFilter(data)   
      setResourceFilter(false)

    }
  }
 
  const onClick = (type: string) => {
    switch (type) {
      case 'positions':
        setFilter(true)
        setResourceFilter(false)
        setIncontractResourceFilter(false)

        return
      case 'resources':
        setFilter(false)
        setResourceFilter(true)
        setIncontractResourceFilter(false)

        return
      case 'incontractresources':
        setFilter(false)
        setResourceFilter(false)
        setIncontractResourceFilter(true)
        return
      case 'company':
        setFilter(false)
        setResourceFilter(false)
        setIncontractResourceFilter(false)

        return
  }
}

  const checkCreateButton = (value: any) => {
    switch (value) {
      case "../applyPositions":
        return 'Apply for this Position'
      case '../addTimesheet':
        return 'Create new'
      default:
        return 'Add new'
    }
  }
  
  return (
    <div className={Styles.dashHead}>
      <div className={Styles.mobileHead}>
        <h3>
          <Breadcrumbs data={item} onItemSelect={onselect} />
          
        </h3>
        {timesheetStatus &&
            <div className={checkTimesheetStatus(timesheetStatus).class}>
              {checkTimesheetStatus(timesheetStatus).value}
            </div>
          }
        {navigateTo && (
          <Button onClick={headerNavigation} variant="primary" size="small">
            {checkCreateButton(navigateTo)}
            {/* {navigateTo === "../applyPositions"
              ? "Apply for this Position"
              : "Add New"} */}
          </Button>
        )}
        {shareButton && <Link to={''} onClick={onShareClick}><Icon icon="ci:share-outline" style={{ "color": "gray"}} width="25"></Icon></Link>}
        {priority && <div className={classnames("headWithLabel", Styles.headWithLabel)}><label className={priorityClass(priority) }>{checkPriority(priority)}</label></div>}
        {popupMenu && (
          <PopupMenu>
            <div className={Styles.popupLinks}>
              <Link to="" onClick={() => updatePosition('edit')}><Icon icon="lucide:edit-2"/>Edit</Link>
              <Link to="" onClick={() => updatePosition( jobStatus === 3 ? 'reopen' : 'close')}><Icon icon="ep:circle-close" />{jobStatus === 3 ? 'Reopen Position' : 'Close Position'}</Link>
              <Link to="" className={Styles.danger} onClick={() => updatePosition('delete')} ><Icon icon="material-symbols:delete-outline-rounded" />Delete</Link>
            </div>
          </PopupMenu>
        )}
      </div>
      {searchChange && <SearchBar searchChange={changeSearch} onClick={onClick} type={type} filterNumber={filterNumber} filtervalues={filterValues} tagClose={(data: any) => { closeTag(data); setDefaultValues(data) }} />}
      {incontractResourceFilter && <IncontractFilter onClose={() => setIncontractResourceFilter(false)} clickHandler={(data: any) => clickHandler(data, 'incontractresources')} />}
      {resourceFilter && <ResourceFilter onClose={() => setResourceFilter(false)} ClickHandler={(data: any) => clickHandler(data, 'resources')} defaultValues={filterValues}  skillsList={skillsList} />}
      {filter && <PositionFilter onClose={() => setFilter(false)} ClickHandler={(data: any) => { clickHandler(data,'positions'); setFilter(false)}}  defaultValues={filterValues} skillsList={skillsList} jobRolesList={jobRolesList}  />}
      <div className={Styles.notification}>
        {/* <Link to="/help">
          <Icon icon="charm:help" />
        </Link> */}
        <Link to="/settings">
          <Icon icon="tabler:settings" />
        </Link>
        {/* <Link to="#">
          <Icon icon="iconoir:bell" />
        </Link> */}
      </div>
    
    </div>
  );
};

export default DashboardHeader;

function useDebounce(value: any, delay: any) {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);  
  useEffect(
      () => {
          // Update debounced value after delay
          const handler = setTimeout(() => {
              setDebouncedValue(value);
          }, delay);
          // Cancel the timeout if value changes (also on delay change or unmount)
          // This is how we prevent debounced value from updating if value is changed ...
          // .. within the delay period. Timeout gets cleared and restarted.
          return () => {
              clearTimeout(handler);
          };
      },
      [value, delay] // Only re-call effect if value or delay changes
  );
  return debouncedValue;
}
